import web1 from "../src/images/1.jpg";
import web2 from "../src/images/2.jpg";
import web3 from "../src/images/3.jpg";
import web4 from "../src/images/4.jpg";
import web5 from "../src/images/5.jpg";
import web6 from "../src/images/6.jpg";

const Sdata=[
    {
        imgsrc:web1,
        title:"First Asan",
    },
    {
        imgsrc:web2,
        title:"Second Asan",
    },
    {
        imgsrc:web3,
        title:"Third Asan",
    },
    {
        imgsrc:web4,
        title:"Fourth Asan",
    },
    {
        imgsrc:web5,
        title:"Fifth Asan",
    },
    {
        imgsrc:web6,
        title:"Sixth Asan",
    },
];

export default Sdata;